import { render, staticRenderFns } from "./incl-catalogPageElement.vue?vue&type=template&id=07498a08&scoped=true"
import script from "./incl-catalogPageElement.vue?vue&type=script&lang=js"
export * from "./incl-catalogPageElement.vue?vue&type=script&lang=js"
import style0 from "./incl-catalogPageElement.vue?vue&type=style&index=0&id=07498a08&prod&lang=scss&scoped=true"
import style1 from "./incl-catalogPageElement.vue?vue&type=style&index=1&id=07498a08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07498a08",
  null
  
)

export default component.exports